import { Button, styled } from "@mui/material";
import colors from "colors/color";
import { COLORS } from "colors/color";

export const PostButton = styled(Button)(({ theme }) => ({
  borderRadius: "10px",
  backgroundColor: COLORS.button_color,
  color: COLORS.white,
  textTransform: "none",
  px: 1,
  width: "180px",
  height: "50px",
  fontFamily: "Poppins",
  fontSize: "1.1rem",
  fontWeight: "400px",
  "&:hover": {
    backgroundColor: COLORS.title_color,
    borderColor: COLORS.title_color,
    color: COLORS.white,
  },
}));
export const NewPostButton = styled(Button)(({ theme }) => ({
  width: 186,
  height: 50,
  borderRadius: "11px",
  border: "1px solid #0017E7",
  padding: "14px 20px",
  background: "#FFFFFF",
  color: "#0017E7",
  textTransform: "none",
  fontFamily: "Poppins",
  fontWeight: 400,
  fontSize: "14px",
  lineHeight: "100%",
  boxSizing: "border-box",
  transition: "all 0.3s ease",
  "&:hover": {
    background: "#0017E7",
    color: "#FFFFFF",
    borderColor: "#0017E7",
    boxShadow: "0px 4px 8px rgba(0, 23, 231, 0.25)",
  },
  "&:active": {
    background: "#000FA8",
    transform: "scale(0.98)",
  },
}));
export const SearchButton = styled(Button)(({ theme }) => ({
  borderRadius: "10px",
  backgroundColor: COLORS.button_color,
  textTransform: "none",
  px: 1,
  width: 88,
  height: 40,
  fontFamily: "Poppins",
  fontSize: "1.1rem",
  fontWeight: "400px",
}));
export const CancelButton = styled(Button)(({ theme }) => ({
  height: "100%",
  color: COLORS.button_color,
  border: "1px solid",
  borderColor: COLORS.button_color,
  backgroundColor: COLORS.white,
  fontFamily: "Poppins",
  borderRadius: "8px",
  fontSize: "13px",
  "&:hover": {
    backgroundColor: COLORS.title_color,
    borderColor: COLORS.title_color,
    color: COLORS.white,
  },
}));
export const NextButton = styled(Button)(({ theme }) => ({
  height: "100%",
  color: COLORS.white,
  border: "1px solid",
  borderColor: COLORS.button_color,
  backgroundColor: COLORS.button_color,
  borderRadius: "8px",
  fontFamily: "Poppins",
  fontSize: "13px",
  "&:hover": {
    backgroundColor: COLORS.title_color,
    borderColor: COLORS.title_color,
    color: COLORS.white,
  },
}));

export const NewSearchButton = styled(Button)({
  backgroundColor: "#0017e7",
  color: "white",
  padding: "8px 32px",
  borderRadius: 11,
  fontFamily: "Poppins",
  fontSize: 14,
  "&:hover": {
    backgroundColor: "rgba(0, 23, 231, 0.9)",
  },
});
export const NewCreateOfferButton = styled(Button)({
  backgroundColor: colors.primary,
  color: "#fff",
  padding: "8px 24px",
  borderRadius: 11,
  fontFamily: "Poppins",
  fontWeight: 400,
  fontSize: 12,
  maxWidth: 140,
  height: 48,
  textTransform: "none",

  borderRadius: 10,
  "&:hover": {
    // fontWeight:600,
    backgroundColor: "rgba(219, 223, 255, 0.9)",
    color: colors.primary,
    boxShadow: "none",
    border: "1px solid ",
    borderColor: colors.primary,
  },
});
export const OutlinedButton = styled(Button)({
  color: "#fff",
  padding: "8px 24px",
  fontFamily: "Poppins",
  fontWeight: 400,
  fontSize: 12,
  // maxWidth: 140,
  height: 48,
  textTransform: "none",
  color: `${colors.primary}`,
  border: `1px solid ${colors.primary}`,
  backgroundColor: "white",
  borderRadius: 10,
  "&:hover": {
    backgroundColor: "rgba(219, 223, 255, 0.9)",
    // color: colors.primary,
    boxShadow: "none",
    border: "1px solid ",
    borderColor: colors.primary,
  },
});
export const NewCancelButton = styled(Button)({
  backgroundColor: "#fff",
  color: "#FF0000",
  padding: "8px 32px",
  borderRadius: 11,
  fontFamily: "Poppins",
  fontWeight: 400,
  fontSize: 12,
  maxWidth: 91,
  height: 48,
  border: "1px solid #FF0000",
  borderRadius: 10,
  textTransform: "none",
  "&:hover": {
    backgroundColor: "rgba(219, 223, 255, 0.9)",
    borderColor: "#FF0000",
  },
});
